module.exports = __webpack_public_path__ + "static/media/main.f7203694.png";